import { useCmaGenerateLiveChartDataCreateQuery } from "@app/api/carApi.generated";
import {
  AssetClassLoadType,
  useAssetClasses,
} from "@app/features/assets/useAssetClasses";
import { useTheme } from "@mui/material";
import { getDftItem } from "./useAssetClassSummaryStat";
import { useMemo } from "react";

export const useAssetClassGenerateLiveChartData = (params: {
  assetClassLevel4Id: string;
}) => {
  const assetClasses = useAssetClasses({
    type: AssetClassLoadType.allFirm,
  });

  const theme = useTheme();

  const data = useCmaGenerateLiveChartDataCreateQuery({
    liveChartDataRequest: {
      asset_class_id: params.assetClassLevel4Id,
    },
  });

  return useMemo(() => {
    const isLoading = assetClasses.isLoading || data.isLoading;

    const assetClass = assetClasses.items.find(
      (i) => i.level4Id === params.assetClassLevel4Id,
    );

    const dftItem =
      assetClass && data.data
        ? getDftItem({ theme, assetClass, summaryStatItem: data.data })
        : undefined;

    return {
      isLoading,
      dftItem,
    };
  }, [
    assetClasses.isLoading,
    assetClasses.items,
    data.data,
    data.isLoading,
    params.assetClassLevel4Id,
    theme,
  ]);
};
